import { post, get, put, del } from 'aws-amplify/api';
import useSWR, { mutate } from 'swr';



async function getStatementQualityReport() {


  const payload = {
    apiName: 'CaseStatementQualityReportApi',
    path: 'statement_quality/report',

  }
  const restOperation = get(payload);


  const { body } = await restOperation.response;
  let json = await body.json();

  return json



}



export function useGetStatementQualityReport(ssmPath, shouldFetch = true) {
  const result = useSWR(shouldFetch ? 'STATEMENT_QUALITY_REPORT' : null, (path) => getStatementQualityReport());
  return result
}

export function refreshStatementQualityReport() {
  mutate('STATEMENT_QUALITY_REPORT');
}

async function getDocumentQualityReport(documentId, queryParams) {

  let queryString = new URLSearchParams(queryParams).toString();

  const payload = {
    apiName: 'CaseStatementQualityReportApi',
    path: `document_quality/${documentId}?${queryString}`,
  }
  const restOperation = get(payload);
  const { body } = await restOperation.response;
  let json = await body.json();
  return json
}

export function useGetDocumentQualityReport(documentId, queryParams = {}, shouldFetch = true) {
  const result = useSWR(shouldFetch && documentId ? ["DOCUMENT_QUALITY_REPORT", documentId] : null, (key) => getDocumentQualityReport(documentId, queryParams));
  return result
}

export async function getTransactionDetail(transactionId) {
  const payload = {
    apiName: 'CaseStatementQualityReportApi',
    path: `transaction_detail/${transactionId}`,
  };
  const restOperation = get(payload);
  const { body } = await restOperation.response;
  return body.json();
}

